<template>
  <div class="header">
    <div style="color: #359186;float: left;font-size: 23px;  align-items: center;margin-top: 18px;width: 230px" >
<!--     <div style=" float: left;">自动巡检系统  </div>-->
      <div style="font-size: 13px; text-align: center;margin: auto " >
        巡检目标: http://192.168.51.1:8090
      </div>
    </div>
    <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
      text-color="#fff"
      active-text-color="#359186"
      >
      <el-menu-item index="OverView">首页概览</el-menu-item>
      <el-menu-item index="OffLineStatus">无线巡检</el-menu-item>
      <el-menu-item index="RealtStatus">有线巡检</el-menu-item>
      <el-menu-item index="SensorError">传感器异常</el-menu-item>
      <el-menu-item index="SendEmailRecords">邮件发送记录</el-menu-item>
      <el-menu-item index="NodeManage">中间件管理</el-menu-item>
      <el-menu-item index="CheckDiary">巡检日志</el-menu-item>
      <el-menu-item index="UserManage" v-if="isshow">账户设置</el-menu-item>
      <el-menu-item index="Login"  v-if="!isshow">退出登录</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {computed, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useStore} from 'vuex'
import {ElMessage} from "element-plus/lib/components";
export default {
  name: 'Header',
  setup(props, ctx) {
    let router = useRouter();
    let route = useRoute();
    let store = useStore();
    let index = ref('OffLineStatus')
    let handleSelect = (key, keyPath) => {
      store.state.nodeId = "";
      store.state.nodeLable =  '';
      store.state.nodeData =  {node:['empty','empty','empty','empty','empty','empty']},
      index.value = key;
      if(key == "Login")
      {
        localStorage.setItem("username"," ");
        localStorage.setItem("password"," ");
        console.log("Login")
      }
      router.push({
        path: '/' + key
      })
    }
    let activeIndex = computed(() => {
      console.log('打印路由', route.path.replace('/', ''));
      return route.path.replace('/', '');
    })
    return {
      activeIndex,
      handleSelect
    }
  },
  methods:{
    checkadmin(){
      let username = localStorage.getItem("username");
      if (username == "admin"){
        return true;
      }
      return  false;
    }
  },
  created() {
    this.isshow = this.checkadmin();

  }
}
</script>

<style lang="scss">
  .header{
    height: 50px;
    width: 100%;
    background-color: #303749;
    .el-menu{
      height: 50px;
      //width: calc(100% - 460px);
      width: auto;
      background-color: #303749;
      color: #fff;
      border-bottom: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      // margin: auto;
      .el-menu-item{
        height: 50px;
        padding: 0 20px;
        width: 10%;
      }
      .el-menu-item.is-active{
        background-color: #303749 !important;
        font-size: 20px;
      }
      .el-menu-item:hover{
        background-color: #303749 !important;
        font-size: 20px;
        color: #359186 !important;
        border-bottom: 2px solid #359186;
      }
    }
  }
</style>
